import { render, staticRenderFns } from "./corporateUsersForm.vue?vue&type=template&id=a203a7e4&scoped=true&"
import script from "./corporateUsersForm.vue?vue&type=script&lang=js&"
export * from "./corporateUsersForm.vue?vue&type=script&lang=js&"
import style0 from "./corporateUsersForm.vue?vue&type=style&index=0&id=a203a7e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a203a7e4",
  null
  
)

export default component.exports